<template>
  <div class="emd-card-grid__row">
    <TId
      :title="$t('charge.detail.payment-method.safetypay.tid')"
      :t-id="lastTransaction.acquirer_tid"
    />

    <DetailAt
      :updated-at="updatedAt"
      :created-at="createdAt"
    />
  </div>
</template>

<script>
export default {
  name: 'ChargesPaymentMethodSafetyPay',

  components: {
    DetailAt: () =>
      import(
        /* webpackChunkName: "detail-at" */ '../../components/DetailAt.vue'
      ),
    TId: () => import(/* webpackChunkName: "tid" */ '../../components/TId.vue')
  },

  props: {
    lastTransaction: {
      required: true
    }
  },

  computed: {
    updatedAt () {
      return {
        title: this.$t('charge.detail.payment-method.safetypay.updated-at'),
        date: this.lastTransaction.updated_at
      }
    },

    createdAt () {
      return {
        title: this.$t('charge.detail.payment-method.safetypay.created-at'),
        date: this.lastTransaction.created_at
      }
    }
  }
}
</script>
